<template>
    <b-modal id="send-document-modal" title="Kirim Dokumen" @show="resetModal">
        <div class="">
            <form class="form-horizontal form-material">
                <div class="form-group">
                    <div class="col-md-12">
                        <input type="file" id="file" ref="file" v-on:change="handleFileUpload" />
                    </div>
                    <div class="col-md-12">
                        <p class="text-danger">*caption tidak akan ditampilkan ke customer</p>
                        <input type="text" class="form-control" placeholder="Caption" v-model="caption">
                        <div class="form-control-feedback text-danger">
                        </div>
                    </div>
                    <!--div class="col-md-12 m-b-20">
                        <input type="textarea" class="form-control" placeholder="Deskripsi" v-model="messageText">
                        <div class="form-control-feedback text-danger">
                        </div>
                    </div-->
                    
                </div>
            </form>
        </div>
        <b-progress v-if="isSendInProgress" :value="uploadPercentage" show-progress animated></b-progress>
        <ErrorMessage v-bind:error="error" />
        <template v-slot:modal-footer>
            <button type="button" class="btn btn-default waves-effect"
                @click="$bvModal.hide('send-document-modal')">Batal</button>
            <button type="button" class="btn btn-default waves-effect" id="btn-send-image" @click="uploadFile">
                <i v-if="isSendInProgress" class="fa fa-circle-o-notch fa-spin"></i> &nbsp;Upload ke media</button>
            <button type="button" class="btn btn-primary waves-effect" id="btn-send-image" @click="submitFile">
                <i v-if="isSendInProgress" class="fa fa-circle-o-notch fa-spin"></i> &nbsp;Kirim</button>
        </template>
    </b-modal>
</template>

<script>
    import ErrorMessage from '../components/ErrorMessage'
    import axios from 'axios'
    const uuidv4 = require('uuid/v4')

    export default {
        data: function () {
            return {
                file: null,
                urlImage: '',
                caption: '',
                messageText: '',
                error: '',
                isSendInProgress: false,
                uploadPercentage: 0
            }
        },
        methods: {
            resetModal: function () {
                this.file = null;
                this.caption = '';
                this.urlImage = '';
                this.messageText = '';
                this.error = {};
                this.isSendInProgress = false;
                this.uploadPercentage = 0;
            },
            handleFileUpload: function () {
                this.error = {}
                
                if(this.$refs.file.files[0].size > 100000000){
                    this.error = this.$helpers.createError({
                        message: "Max file size 100mb"
                    })
                    document.getElementById("file").value=null;
                    return
                }

                this.file = this.$refs.file.files[0];
                this.error = {};
            },
            submitFile: async function () {
                var appSubmit = this;
                this.error = {}

                if (!this.$helpers.isBlank(this.file)) {
                    this.isSendInProgress = true;
                    this.uploadPercentage = 0;
                    let formData = new FormData();
                    formData.append('file', this.file);
                    formData.append('caption', this.caption);
                    //formData.append('description', this.messageText);
                    formData.append('id', uuidv4());
                    formData.append('channel', this.channel);
                    formData.append('channelId', this.sourceChannelId);
                    formData.append('number', this.destNumber);
                    // if (this.channel == 'FB') {
                    //     formData.append('number', this.destNumber);
                    // } else if (this.channel == 'SMS' || this.channel == 'WA') {
                    //     formData.append('number', this.destNumber);
                    // }

                    if (this.qmOriginId) {
                        formData.append('qmOriginId', this.qmOriginId)
                        formData.append('qmText', this.qmText)
                        formData.append('qmOriginExternalId', this.qmOriginExternalId)
                        formData.append('qmAuthorId', this.qmAuthorId)
                        formData.append('qmAuthorName', this.qmAuthorName)
                    }

                    try {
                        await axios.post(process.env.VUE_APP_API_URL + '/message/' + this.contactId + '/' + this
                            .destNumber + '/document',
                            formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                },
                                onUploadProgress: function (progressEvent) {
                                    appSubmit.uploadPercentage = parseInt(Math.round((progressEvent.loaded /
                                        progressEvent.total) * 100))
                                }
                            }
                        )

                        this.$emit('send-document-callback-api', null)

                        this.$bvModal.hide('send-document-modal');
                        this.$emit('clearQuoted')
                    } catch (error) {
                        this.$emit('send-document-callback-api', error)
                        this.error = this.$helpers.createError(error)
                    }

                    appSubmit.isSendInProgress = false;
                } else {
                    this.error = {
                        html: "document masih kosong atau ukuran file terlalu kecil"
                    }
                }
            },
            uploadFile: async function () {
                var appSubmit = this;
                this.error = {}

                if (!this.$helpers.isBlank(this.file)) {
                    this.isSendInProgress = true;
                    this.uploadPercentage = 0;
                    let formData = new FormData();
                    formData.append('file', this.file);
                    formData.append('caption', this.caption);
                    formData.append('mediaType', 'document');

                    try {
                        await axios.post(process.env.VUE_APP_API_URL + '/attachment',
                            formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                },
                                onUploadProgress: function (progressEvent) {
                                    appSubmit.uploadPercentage = parseInt(Math.round((progressEvent.loaded /
                                        progressEvent.total) * 100))
                                }
                            }
                        )

                        this.$bvModal.hide('send-document-modal');
                        this.$emit('clearQuoted')
                    } catch (error) {
                        this.error = this.$helpers.createError(error)
                    }

                    appSubmit.isSendInProgress = false;
                } else {
                    this.error = {
                        html: "document masih kosong atau ukuran file terlalu kecil"
                    }
                }
            }
        },
        props: [
            'contactId', 'destNumber', 'sourceChannelId', 'channel',
            'qmOriginId', 'qmText', 'qmOriginExternalId', 'qmAuthorId', 
            'qmAuthorName'
        ],
        components: {
            ErrorMessage
        }
    }
</script>